'use client';

// Pas besoin de dynamic import pour le moment - version simplifiée pour le mode dev
export default function OfflineModeClientWrapper() {
  // En mode dev, on ne fait rien
  return null;
}
